module.exports = __webpack_public_path__ + "static/media/licencse.37aa851c.svg";